import React from 'react';
import {Link} from 'react-router-dom';
import '../assets/styles/components/StageMenu.sass';

const VideosMenu = () => (
  <div className="row stage-menu">
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <ul className="stage-menu__list">
            <li className="stage-menu__list--item">
              <Link id="videosPrologo" to="/home-carrera/videos-prologue">
                PRÓLOGO
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa1" to="/home-carrera/videos-stage-one">
                ETAPA 1
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa2" to="/home-carrera/videos-stage-two">
                ETAPA 2
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa3" to="/home-carrera/videos-stage-three">
                ETAPA 3
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa4" to="/home-carrera/videos-stage-four">
                ETAPA 4
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa5" to="/home-carrera/videos-stage-five">
                ETAPA 5
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa6" to="/home-carrera/videos-stage-six">
                ETAPA 6
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default VideosMenu;